module.exports = __webpack_public_path__ + "static/media/rw.a712fac2.png";